import { render, staticRenderFns } from "./Filmography.vue?vue&type=template&id=0963c385&scoped=true&"
import script from "./Filmography.vue?vue&type=script&lang=js&"
export * from "./Filmography.vue?vue&type=script&lang=js&"
import style0 from "./Filmography.vue?vue&type=style&index=0&id=0963c385&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963c385",
  null
  
)

export default component.exports